import axios from 'axios';

// Define the base URL for the API
const BASE_URL = 'https://www.rosscentanni.com/projects/restaurant/api';

const menuService = {
    // Fetch all menu items
    getMenuItems: async () => {
        try {
            const response = await axios.get(`${BASE_URL}/menu`);
            return response.data;
        } catch (error) {
            throw new Error('Error fetching menu items');
        }
    },

    // Add a new menu item
    addMenuItem: async (menuItem) => {
        try {
            const response = await axios.post(`${BASE_URL}/menu`, menuItem, {
                headers: {
                    'Content-Type': 'multipart/form-data', // For required file uploads
                    'Authorization': `Bearer ${localStorage.getItem('adminToken')}`
                }
            });
            return response.data;
        } catch (error) {
            throw new Error('Error adding menu item');
        }
    },

    // Update an existing menu item
    updateMenuItem: async (id, menuItem) => {
        try {
            const response = await axios.put(`${BASE_URL}/menu/${id}`, menuItem, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('adminToken')}`
                }
            });
            return response.data;
        } catch (error) {
            throw new Error('Error updating menu item');
        }
    },

    // Delete a menu item
    deleteMenuItem: async (id) => {
        try {
            const response = await axios.delete(`${BASE_URL}/menu/${id}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('adminToken')}`
                }
            });
            return response.data;
        } catch (error) {
            throw new Error('Error deleting menu item');
        }
    }
};

export default menuService;